<template>
<div   class="container-fluid">

<div class="modal" id="confirmBox" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div style="background-color:#FFFF66" class="modal-header">
        <h5 class="modal-title" id="staticBackdropLabel">
           <i  class="far fa-clone mr-2" aria-hidden="true"></i>
          <strong>UNIFICAZIONE VENDITE</strong></h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div style="color:navy" class="modal-body">
        
        DA VENDITA ID 
         <span style="font-size: 20px"><strong>{{sale1Id}}</strong></span>
          A VENDITA ID 
          <span style="font-size: 20px"><strong>{{sale2Id}}</strong></span>
          
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">ANNULLA</button>
        <button @click="updateMovement()"  type="button" class="btn btn-primary">
          <i  class="far fa-clone mr-2" aria-hidden="true"></i>
          ESEGUI</button>
      </div>
    </div>
  </div>
</div>


<confirm-box v-if="cb.show">     
      <template v-slot:header>
        <strong>{{cb.title}}</strong>    
      </template>
      <template v-slot:body1>
        <h4>{{cb.msg1}}</h4>   
      </template>
      <template v-slot:footer>  
        <button @click="cb.show=false" type="button" class="btn btn-secondary">
         
          NO</button>
        <button @click="processModal()" type="button" data-dismiss="modal" class="btn btn-primary">SI</button>
      </template>    
</confirm-box>  


<customers v-if="cust.modal" @close="setCustomer"></customers>



  <div class="card border-success">
  <div  class="card-header text-white bg-primary">
    <h4> <i  class="fas fa-file-alt mr-2" aria-hidden="true"></i>DDT VENDITA CLIENTE</h4>   
  </div>

  <div  class="card-body"> 
 
   <div class="row">
   <div v-if="type=='search'" class="col-md-4"> 

   <div class="card border-info" >
   <div class="card-header bg-info"><strong>PARAMETRI DI RICERCA</strong></div>
   <div class="card-body text-dark">

  <form name="searchPayment" v-on:submit.prevent="getData()">

          <label class="" for="data"><strong>da DATA VENDITA </strong></label>      
          <input type="date"  class="form-control " id="create_at1"  v-model="date1">

          <label class="" for="data"><strong>a DATA VENDITA </strong></label>      
          <input type="date"  class="form-control " id="create_at2"  v-model="date2">

          
          <label for="staticCustomer" ><strong>Cliente</strong></label>
          <input type="text" readonly class="form-control mb-2"  v-model="cust.search">
            <button  v-if="cust.Id>0"  @click="resetCustomer()" type="button"  class="btn btn-sm btn-warning mb-2 mr-2">
            <i class="fas fa-user-friends mr-2"></i>
              TUTTI I CLIENTI
            </button> 

          <button  @click="openCustomer({},'search')" type="button"  class="btn btn-sm btn-info mb-2">
            <i class="fas fa-search mr-2"></i>
              RICERCA CLIENTE
          </button>  
          
 
        <div class="card-footer mt-3 bg-transparent border-info"> 
          <alert-box  @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
          <button  class="btn btn-primary active float-right">
            <i  class="fas fa-binoculars mr-2" aria-hidden="true"></i>
            CERCA
            <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-3 text-warning" role="status" aria-hidden="true"></span>
          </button>
        </div>
  
  </form>
  </div>
  </div>
  </div>

<div v-else class="col">
 
 <confirm-box1 v-if="cb1.show">     
      <template v-slot:header>
        <strong>{{cb1.title}}</strong>    
      </template>
      <template v-slot:body1>
        <h4>{{cb1.msg1}}</h4>   
      </template>
      <template v-slot:footer>  
        <button @click="cb1.show=false" type="button" class="btn btn-primary float-right">
          OK</button>
      </template>    
  </confirm-box1>  

<!-- TABLE -->  

  <div v-if="type == 'sales'">
  <div v-if="spinner" class="text-center">
  <div class="spinner-grow text-success spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
  </div>  
  <button   @click="items=[],type='search'" type="button"  class="btn btn-secondary mb-2">
    <i style="color:yellow" class="fas fa-reply mr-2"></i>
    ANNULLA
  </button>  

  <div class="salesList" >
  <table class="table mb-0 table-hover pointer ">
    <thead >
      <tr>
        <th>#</th>
        <th>STAMPA DDT</th>
        <th>VEDI PRODOTTI</th>
        <th>ID VENDITA</th>
        <th>SEDE</th>
        <th>DATA</th>
        <th>CLIENTE</th>
        <th class="text-right">TOTALE QTA'</th>
        <th class="text-right">TOTALE €</th>
        
                
      </tr>
    </thead>
    <tbody>
      <tr 

        draggable="true"
        @dragstart='startDrag($event, item)' 
        @drop='onDrop($event, item)' 
        @dragover.prevent
        @dragenter.prevent
        
      
       v-for="(item, index) in filteredItems" :key="index">
      <td>{{index+1}}</td>
       <td>
         <i   @click="packingSlip(item)" class="fas fa-print " aria-hidden="true"></i>
      </td>
      <td>
         <i  @click="viewProducts(item)"  class="fas fa-search " aria-hidden="true"></i>
      </td>
      
      <td class="date_time"><strong>{{item.saleId}}</strong></td>   
      <td class="date_time"><strong>{{item.store}}</strong></td>   
      <td class="date_time"><strong>{{item.create_at}}</strong></td>                
      <td @click="openCustomer(item)" class="date_time text-nowrap"><strong  v-if="item.customer">
        {{item.customer}}</strong>
        <i v-else class="far fa-id-card" aria-hidden="true"></i>
        </td>
      <td class="date_time text-right"><strong>{{fmt2(item.qty)}}</strong></td>
      <td class="date_time text-right"><strong>{{fmt1(item.total1-item.total2)}}</strong></td>
      
          
      </tr> 
    </tbody>
    <!--
        <tfoot>
        <tr>  
       
        <th></th>
        <th></th>
        <th></th>
        
        <th></th>
        <th></th>
      
        <th></th>
        <th class="text-nowrap">TOTALE €</th>
        <th class="text-right">{{fmtCurrency(total.total1)}}</th>
        <th class="text-right">{{fmtCurrency(total.total2)}}</th>
        <th class="text-right">
          {{fmtCurrency(total.total3)}}</th>
        <th> </th>
        <th> </th>
        </tr>
      
      </tfoot> 
      -->
  </table>
  
</div>
<label for="cerca"><strong>
  <i  class="fas fa-filter mr-2" aria-hidden="true"></i>
  Filtra</strong></label>
<input class="form-control" type="text" name="query" v-model="filterKey">

 


</div>



<!-- DETAIL -->
<div v-else-if="type == 'detail'">
  <button  @click="setSales()" type="button"  class="btn btn-secondary mb-2">
    <i style="color:yellow" class="fas fa-reply mr-2"></i>
    ANNULLA
  </button>  
 
  <sale-products v-bind:item="item"></sale-products>
  
 
</div>

<div v-else>
    <button @click="type='sales'" type="button" class="btn btn-secondary ">
       <i style="color:yellow" class="fas fa-reply mr-2"></i>
      ANNULLA</button>
    <packing-slip  v-bind:documentId="documentId" v-bind:movementId="movementId" ></packing-slip>
    
</div>  



</div>  

</div>
</div>
</div>

</div>
</template>
<script>
import alertBox           from '@/components/common/AlertBox.vue';
import api                from '@/api'
import { mapGetters }     from 'vuex';
import packingSlip        from '@/components/shipping/PackingSlipCustomer.vue'
import confirmBox         from '@/components/common/ConfirmBox.vue'
import confirmBox1        from '@/components/common/ConfirmBox.vue'
import saleProducts       from '@/components/frontOffice/SaleProducts.vue'
import customers          from '@/components/customer/CustomerList.vue'
import fmt                  from '@/components/mixins/fmt.js'




export default {
   
  mixins: [fmt],
  components: {alertBox,packingSlip,confirmBox,saleProducts,confirmBox1,customers},
  data() {
    return {
      filterKey              : '',
      item                   : {},
      
      date1                  : new Date().toISOString().slice(0, 10),
      date2                  : new Date().toISOString().slice(0, 10),
      bt_spinner             : false,
      spinner                : false,
     
      msg                    : {
        title                : '',
        body                 : '',
        type                 : 0
      }, 
      items                  : [],
      type                   : 'search',
      documentId             : 0,
      movementId             : 0,
      sale1Id                : 0,
      sale2Id                : 0,
      movementId_To          : 0,
      movementId_From        : 0,        
      documentId_To          : '',
      documentId_From        : '',
     
      cb                     : {title : '',msg1 : '',show:false},
      cb1                    : {title : '',msg1 : '',show:false},
     
      rowId                  : 0,
      cust                   : {'modal':false,'search':'TUTTI','option':'','Id':0},
      
           
    };
  },
  computed :{
   
    ...mapGetters(['storeId','company']) , 
     filteredItems : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
        return items
     },

     
    total : function() {
   
      let  total = {
        total1 : 0,total2:0,total3:0
      }
      this.items.forEach(item => {
        if(item.rowType==2)
        {
          total.total1 += Number(item.row_total)
          total.total2 += Number(item.totalDiscount)
          total.total3 += Number(item.totalPaid)

        }
      })
      return total
    }


  },
  directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        //el.focus();
      }
    }
  },
  mounted: function() {
    //this.getData()
  },
  created: function() {},
  methods: {
    resetCustomer()
    {
      this.cust.Id = 0
      this.cust.search = 'TUTTI'
    },

    openCustomer(item,option)
    {
      this.rowId = item.id

      
      this.cust.option = ''
      if(option)
      {
        this.cust.option = option
      }
      this.cust.modal = true
      


    },
    setCustomer(item)
    {
      
      this.cust.modal = false
      if(this.cust.option)
      {
        

        if(item.customerId)
        {
          this.cust.search = item.last_name + ' ' + item.first_name
          this.cust.Id = item.customerId
      
        
        }
      }
      else
      {
        if(item.customerId)
        {
          this.updateCustomer(item.customerId)
          
        }
      }  
    },

    
    setSales()
    {
      this.products=[]
      this.type = 'sales',
      this.spinner = true
      this.getData()
      

    },
    async updateCustomer(customerId)
    {
       
       
        //this.spinner = true
        var data     = {'customerId' : customerId,'id':this.rowId}        
        var sp       = {'sp'         : 'spUpdateSaleCustomer'}
        var json     = Object.assign(data, sp)
                
        await api.post(json).then(res => {
          if(res.status==200)
            {
              this.getData()  

            }
            else if(res.status==500)
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data 
              this.msg.type = 1
            } 
            else
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1

            } 
        }).catch(err => 
        {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1

        }).finally(() => {
          //this.spinner = false
        });
        
        
       
    },

    async processModal()
     {
        
        this.cb.show = false
        this.spinner = true
        var data     = {'Id' : this.cb.Id,'storeId':this.cb.storeId,'barcode':this.cb.barcode}        
        var sp       = {'sp' : 'spDeleteProductFromSale'}
        var json     = Object.assign(data, sp);
        await api.post(json).then(res => {
          if(res.status==200)
            {
              this.msg.title = 'ELIMINAZIONE EFFETTUATA.'
              this.msg.body = ''
              this.msg.type = 0
              //this.getData()  

            }
            else if(res.status == 500)
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data 
              this.msg.type = 1
            } 
            else
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1

            } 
        }).catch(err => 
        {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1

        }).finally(() => {
             this.spinner = false
        });
        
        
        
     
     },
    viewProducts(item)
     {
       this.item = item
       this.type = 'detail'

       
     }, 
    async updateMovement()
      {
        
        this.msg.title = ''
        $('#confirmBox').modal('hide')

        this.spinner = true
        var data     = {'movementId_From' : this.movementId_From,'movementId_To' : this.movementId_To,'documentId':this.documentId_From,'saleId':this.sale1Id}        
        var sp       = {'sp'              : 'spUpdateSaleMovementFromDragAndDrop'}
        var json     = Object.assign(data, sp)
                
        await api.post(json).then(res => {
          if(res.status==200)
            {
              this.msg.title = 'UNIFICAZIONE EFFETTUATA.'
              this.msg.body = ''
              this.msg.type = 0
              this.getData()  

            }
            else if(res.status==500)
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data 
              this.msg.type = 1
            } 
            else
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1

            } 
        }).catch(err => 
        {
              //console.log(err.message) 

              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1

        }).finally(() => {
          //this.spinner = false
        });
        
        
        
     
      },
     
    startDrag (evt, item) {
              
        this.msg.title = ''
        evt.dataTransfer.dropEffect = 'move'
        evt.dataTransfer.effectAllowed = 'move'
        evt.dataTransfer.setData('item_from', JSON.stringify(item))
      

      },
      onDrop (evt, item_to) {
      
      const item_from = JSON.parse(evt.dataTransfer.getData('item_from'))
      
      

      if(item_from.stockMovementId != item_to.stockMovementId && item_from.movementType == item_to.movementType && item_from.storeId == item_to.storeId )
      {
        this.sale1Id         = item_from.saleId
        this.sale2Id         = item_to.saleId
        this.documentId_From = item_from.documentId
        this.documentId_To   = item_to.documentId
        this.movementId_To   = item_to.stockMovementId
        this.movementId_From = item_from.stockMovementId

        $('#confirmBox').modal('show')
    
      }
      else
      {
        
        
        this.cb1.title = 'ATTENZIONE '  
        this.cb1.msg1  = 'RIGHE VENDITE NON COMPATIBILI.'
        this.cb1.show  = true
        
        
        
      }
      


      

      },

    
      

    packingSlip(item)
    {
      

      this.documentId = item.documentId
      this.movementId = item.stockMovementId
      this.type = 'print'
    },
   
    async getData() 
    {
      
      
      this.msg.title = '' 
      this.items = []
      if(!this.date1 || !this.date2)
      {
        
        this.msg.title = "ATTENZIONE"
        this.msg.body  = 'Data di vendita non valida.'
        this.msg.type = 1
       
        return
      }
      
      var sp    = {'sp':'spAllSales'}
     
      var data  = {'date1':this.date1,'date2':this.date2,'companyId':this.company.Id,'customerId':this.cust.Id}
      var json  = Object.assign(data, sp)

      this.bt_spinner = true
      
      

      await api.post(json).then(res => {
        if(res.status==200)
          {
            this.items    = res.data.recordsets[0]
            
            if(this.items.length>0)
            {
              this.type = 'sales'  
            }
            else
            {
              this.type = 'search'
            }

            if(this.items.length ==0 )
            {
              
              this.msg.title = "ATTENZIONE "
              this.msg.body = 'DATI INESISTENTI.'
              this.msg.type = 1
     
            }
            
         
          }
          else if(res.status==500)
          {
            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res.data
            this.msg.type  = 1

          } 
          else
          {
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1                  
            

          } 
      }).catch(err => 
      {
          
      this.msg.title = 'ATTENZIONE '
      this.msg.body  = err.message
      this.msg.type  = 1  

      }).finally(() => {
        this.bt_spinner = false
        this.spinner = false
      });

    },
    


  }
};
</script>
<style scoped>

.salesList {
position  : relative;
height    : 500px;
overflow  : auto;
}


.fa-print
{
  cursor: pointer
}
.pointer:hover
{
  
  cursor           : pointer;
}


.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   :  hwb(45 4% 9%);  
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }
 .table tfoot  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 24px;
    background   : whitesmoke;
    color        : darkgreen;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;

 } 

.form-check-label
{
  cursor: pointer;
}
h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
.date_time
{
  font-size: 16px;
}
 .table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}
</style>